export type Commands = {
  OutFile: string
  VIProductVersion?: string
  VIAddVersionKey: Array<string>
  Unicode: boolean
  Icon?: string
  SetCompress?: "off"
  SetCompressor?: "zlib"
}
